import { nodeViewDecorators } from "./../../../../ricos-common-plugins/viewer.js";
import { BreakoutDecorator } from "./breakoutDecorator.js";
import { Decorators as NodeViewDecorators } from "./nodeViewDecorators.js";
const decorators = [
  ...nodeViewDecorators,
  BreakoutDecorator
];
var decorators_default = NodeViewDecorators;
export {
  decorators,
  decorators_default as default
};
//# sourceMappingURL=index.js.map
